import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { BackArrowIcon } from '../../assets/Icons/SVG';
import { MEDIA_TYPE, RED_LOGO } from '../../shared/constants/common.js';
import { useNavigation } from '../../shared/utils/useNavigation';
import { isUserLoggedIn } from '../../shared/utils/function';
import { fetchUser } from '../../shared/actions/userActions';

const HeaderSection = ({
  type = 'text',
  title,
  handleBack: externalHandleBack, // Allow external override if needed
  className = '',
  hideBackButton = false,
  history
}) => {
  const navigate = useNavigation();
  const isLoggedIn = isUserLoggedIn();
  const dispatch = useDispatch();
  // Fetch user when login status changes
  useEffect(() => {
    const fetchUserData = async () => {
      if (isLoggedIn) {
        await dispatch(fetchUser());
      }
    };
    fetchUserData();
  }, [isLoggedIn, dispatch]);

  // Centralized back navigation handler
  const handleBackNavigation = useCallback(() => {
    try {
      // Check if there's history to go back to
      if (history && history.length > 1) {
        navigate.back();
      } else {
        // If no history, redirect to discover page as default
        navigate.toDiscover();
      }
    } catch (error) {
      // Fallback to discover page on error
      navigate.toDiscover();
    }
  }, [history, navigate]);

  // Use external handler if provided, otherwise use internal handler
  const handleBack = externalHandleBack || handleBackNavigation;
  
  return (
    <>
      {type === MEDIA_TYPE.IMAGE ? (
        <header className={`cm_header ${className}`}>
          <div className="header-content">
            {!hideBackButton && (<button className="modern-legal-back-btn" onClick={handleBack}>
              <BackArrowIcon />
            </button>
            )}
            <div className={`ImageDiv ${hideBackButton ? 'ImageDiv-centered' : ''}`}>
              <img
                src={RED_LOGO}
                alt="Juicy House"
                className="header-logo"
              />
            </div>
          </div>
        </header>
      ) : (
        <header className={`cm_header ${className}`}> 
          <div className="header-content">
            {!hideBackButton && (
              <button className="modern-back-btn" onClick={handleBack} aria-label="Go back">
                <BackArrowIcon />
              </button>
            )}
            <h1 className="modern-header-title" style={{ textAlign: hideBackButton ? 'center' : 'left' }}>{title}</h1>
          </div>
        </header>
      )}
    </>
  );
};

// export default HeaderSection;
export default withRouter(HeaderSection); 
